
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"13","height":"13"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 6637"}},[_c('path',{attrs:{"data-name":"Rectangle 4048","d":"M5 0h3v13H5z"}}),_c('path',{attrs:{"data-name":"Rectangle 4049","d":"M13 5v3H0V5z"}})])])
          )
        }
      }
    